import Vue from 'vue'
import Router from 'vue-router'
import fetch from '../plugin/axios/fetch.js'
import { checkBrowser, otherApp } from '../plugin/channel/setUserChannel'
import { auth } from './auth'
import { urlTokenAuth } from './urlTokenAuth'
import * as types from '../store/modules/emsCli/mutationTypes'
// import { setDocumentTitle } from '../plugin/setTitle/setDocumentTitle'
import { isForward } from './pageTransition'
// 路由数据
import routes from './routerConfig'
import store from '../store/index.js'
import { isSignedLatestAgreement } from '@/plugin/util/apiProtocol.js'
import { getUserInfo } from '@/api/index'
import { deAesEcb } from '@/plugin/decode/index'

Vue.use(Router)

const router = new Router({
  routes
})

export default router

/**
 * 切换动画名称
 */
const SLIDE_LEFT = 'slide-left'
const SLIDE_RIGHT = 'slide-right'

router.beforeEach(async (to, from, next) => {
  if (router.app.$store) {
    // 如果不需要过渡动画，直接走next
    if (router.app.$store.state.emsCli.appShell.needPageTransition) {
      // 判断当前是前进还是后退，添加不同的动画效果
      let pageTransitionName = isForward(to, from) ? SLIDE_LEFT : SLIDE_RIGHT
      router.app.$store.commit(`emsCli/appShell/${types.SET_PAGE_TRANSITION_NAME}`, { pageTransitionName })
      // console.log(router.app.$store.state.appShell.pageTransitionName, 'pageTransitionName')
    }
  }
  if (process.env.VUE_APP_NODE_ENV === 'development') {
    let permanentToken =
      'eyJhbGciOiJIUzI1NiJ9.eyJTU1NfVVJMIjoiIiwiUEhPTkUiOiIxMzkyMzE4MzkzNiIsIlVTRVJfSUQiOiIzNDc0ZTNjYjNlOTA0ODZkYTc5YTEzMDM4N2Q1YThlNCIsIlVTRVJfQ0hBTk5FTCI6IldFQ0hBVF9NSU5JX1BST0dSQU0iLCJJU1NVRVJfQVQiOjE3NzQ1NzUwNTMyMzMsIk9QRU5fSUQiOiJvOUZrUTBhZFZwRThZWXZOWHpBVE53RXZtSVpvIiwiSVNTVUVSIjoibmV3LWdlbmVyYXRpb24tYXBpIiwiUEhPTkVfSUQiOiIiLCJleHAiOjE3Nzk3NTkwNTN9.sj4oPP5cipOIJLhoZ_fNWN5rxFjgiamCbiGwVZEtod8'
    // let permanentToken = 'eyJhbGciOiJIUzI1NiJ9.eyJTU1NfVVJMIjoiIiwiUEhPTkUiOiIxNTgwOTIzODE3MyIsIlVTRVJfSUQiOiI0MmM0YTRjZDZmMWQ0MGU5OTQ0NzE4OGI5ZjI0Y2Y2MyIsIlVTRVJfQ0hBTk5FTCI6IldFQ0hBVCIsIklTU1VFUl9BVCI6MTcyODk4NDQ1OTIyMiwiT1BFTl9JRCI6Im9pZkNtampBZzZPWVNxb0JJc184dFQtSXg0cEUiLCJJU1NVRVIiOiJuZXctZ2VuZXJhdGlvbi1hcGkiLCJQSE9ORV9JRCI6IiIsImV4cCI6MTczNDE2ODQ1OX0.NqCqaW6lZAjp60eFmEBvQ23wQ6zrVmKZ4phcMi-qK10'
    fetch.setToken(permanentToken)
    localStorage.setItem('FREIGHT-TOKEN', permanentToken)
    next()
  }
  // 快应用环境下直接用永久token
  if (checkBrowser() === 'HWQUICK') {
    let permanentToken = 'eyJhbGciOiJIUzI1NiJ9.eyJTU1NfVVJMIjoiIiwiUEhPTkUiOiIxMzgwMDEzODAwMCIsIlVTRVJfSUQiOiIxIiwiVVNFUl9DSEFOTkVMIjoiV0VDSEFUIiwiSVNTVUVSX0FUIjoxNTcxMzA5Mzg4NzAwLCJPUEVOX0lEIjoicGVybWFuZW50IGFydGlmaWNpYWwgY29kZSIsIklTU1VFUiI6Im5ldy1nZW5lcmF0aW9uLWFwaSIsIlBIT05FX0lEIjoiIiwiZXhwIjozMTQ4MTA5Mzg4fQ.MX-qjYDLDP04G_jyzC31HzvLZZcDrC2FIiEOoMyBFr0'
    fetch.setToken(permanentToken)
    next()
  }
  if (checkBrowser() === 'WECHAT') {
    wx.miniProgram.getEnv(function (res) {
      if (res.miniprogram) {
        // 微信小程序
        urlTokenAuth(next)
      } else {
        // 微信H5
        auth(next)
      }
    })
    // if (window.navigator.userAgent.includes('miniProgram')) {
    //   urlTokenAuth(next)
    // } else {
    //   auth(next)
    // }
  }
  if (checkBrowser() === 'ALIPAY') {
    // eslint-disable-next-line no-undef
    my.getEnv(function (res) {
      if (res.miniprogram) {
        urlTokenAuth(next)
        next()
      } else {
        auth(next)
      }
    })
  }
  if (otherApp()) {
    urlTokenAuth(next)
  }
})

router.afterEach(async (to, from) => {
  console.log('路由后置拦截 ', to)
  let user = store.state.user
  console.log('用户登录信息', user)
  if (!user.userId) {
    // 调用接口获取用户信息
    const info = await getUserInfo()
    if (info && Object.keys(info).length > 0) {
      const { isLogin = 0, openId = '', phone = '', phoneNum = '', userId = '', userName = '' } = info
      let obj = {
        userId,
        userName,
        userPhone: deAesEcb(phone),
        aesEcbPhone: phone,
        enCodePhone: phoneNum, // 加密的手机号,给在线客服带参用的
        isLogin,
        openId
      }
      store.dispatch('user/setUserInfo', obj)
      user = obj
    }
  }
  if (+user.isLogin !== 1 || to.name === 'historyProtocol') return
  const { privacy } = await isSignedLatestAgreement({ types: ['privacy'] })
  console.log('是否签署协议：' + privacy)
  if (!privacy) {
    // 未签署并且已登录，弹出提示签署最新协议的弹窗
    store.commit('protocol/setShowNotice', true)
  }
})
